<template>
    <div class="animated fadeIn">
        <BaseInventory
            categoryId="1"
            categoryName="Sinus"
            categorySectionIcon="fa-bolt"
        />
    </div>
</template>

<script>
import BaseInventory from './base/BaseInventory'

export default {
    name: 'sinus',
    components: { BaseInventory }
}
</script>
